import { useCallback } from 'react';
import { useParams, useRouter } from 'next/navigation';
import { getLocalizationInfo } from 'project.config';
import usePath from './usePath';

const useLanguage = () => {
  const router = useRouter();
  const { path } = usePath();
  const { locale } = useParams();
  const { country, language } = getLocalizationInfo(locale);
  const setLanguage = useCallback(
    (newLanguage: string) => {
      router.push(`/${country.countryCode.toLowerCase()}-${newLanguage.slice(0, 2).toLowerCase()}${path}`);
    },
    [country, path, router],
  );
  return [language, setLanguage] as const;
};

export default useLanguage;
